import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { ArrowRight, Sparkles } from 'lucide-react'
import { readingApi } from '@/api/reading'
import { Button } from '@/components/ui/Button'

interface KeepLearningEndlessFlowProps {
  visible: boolean
}

export function KeepLearningEndlessFlow({ visible }: KeepLearningEndlessFlowProps) {
  const navigate = useNavigate()

  const nextRecommendation = useMutation({
    mutationFn: () => readingApi.getRecommended('keep_learning'),
    onSuccess: (recommendation) => {
      navigate(`/reading/${recommendation.article.id}?keepLearning=1`, { replace: false })
    },
  })

  if (!visible) {
    return null
  }

  return (
    <div
      className="mt-8 rounded-xl border border-primary/20 bg-primary/5 p-5 text-center"
      data-testid="keep-learning-endless-flow"
    >
      <div className="mb-2 flex justify-center">
        <Sparkles className="h-5 w-5 text-primary" />
      </div>
      <p className="text-sm font-medium text-foreground">Want to keep going?</p>
      <p className="mt-1 text-sm text-muted-foreground">
        Continue with another article picked for you.
      </p>
      <Button
        className="mt-4 min-h-12 w-full gap-2"
        loading={nextRecommendation.isPending}
        onClick={() => nextRecommendation.mutate()}
        data-testid="keep-learning-continue-recommendation"
      >
        Continue with another recommendation
        <ArrowRight className="h-4 w-4" />
      </Button>
    </div>
  )
}
